import { useContext } from "react";
import { useLocation, Link, matchPath } from "react-router-dom";
import { ThemeContext } from "../../theme/ThemeContext";
import { FaChevronRight } from "react-icons/fa";

const routeConfig = [
  { path: "/dashboard", clickable: true },
  { path: "/courses", clickable: true },
  { path: "/courses/:courseName", clickable: true },
  { path: "/courses/:courseName/catalogues", clickable: true },
  { path: "/courses/:courseName/catalogue", clickable: true },
  { path: "/courses/:courseName/users", clickable: true},
  { path: "/courses/:courseName/documents", clickable: true},
  { path: "/courses/:courseName/view-documents", clickable: true},
  { path: "/courses/:courseName/vms", clickable: true },
  { path: "/courses/:courseName/lvms", clickable: true },
  { path: "/courses/:courseName/gvms", clickable: true},
  { path: "/masters-document-types", clickable: true },
  { path: "/masters-catalogues", clickable: true },
  { path: "/document-dashboard", clickable: true },
  { path: "/document", clickable: true },
  { path: "/document/:docTypeId", clickable: true },
  { path: "/document-dashboard/documents", clickable: true },
  { path: "/document-dashboard/documents-mapping", clickable: true },
  { path: "/catalogue-dashboard", clickable: true },
  { path: "/catalogue-dashboard/catalogue", clickable: true },
  { path: "/catalogue-dashboard/catalogue/:categoryId", clickable: true },
  { path: "/catalogue-dashboard/catalogue/all", clickable: true },
  { path: "/catalogue-dashboard/catalogue/add", clickable: false },
  { path: "/catalogue-dashboard/catalogue/edit/:incidentName", clickable: false },
  { path: "/catalogue-dashboard/catalogue-mapping", clickable: true },
  { path: "/assessment-dashboard", clickable: true },
  { path: "/masters-assessments", clickable: true },
  { path: "/masters-assessments/add", clickable: true },
  { path: "/masters-assessments/:assessmentName/edit", clickable: false },
  { path: "/masters-assessments/:assessmentName", clickable: true },
  { path: "/masters-assessments/:assessmentName/mcq", clickable: true },
  { path: "/masters-assessments/:assessmentName/mcq-attendees", clickable:true},
  { path: "/masters-assessments/:assessmentName/practical-attendees", clickable: true},
  { path: "/masters-assessments/:assessmentName/mcq-attendees/:name", clickable: true },
  { path: "/masters-assessments/:assessmentName/practical-attendees/:name", clickable: true},
  { path: "/masters-assessments/:assessmentName/mcq-sessions", clickable: true },
  { path: "/masters-assessments/:assessmentName/practical-sessions", clickable: true },
  { path: "/masters-assessments/:assessmentName/mcq/import", clickable:true},
  { path: "/masters-assessments/:assessmentName/practical", clickable: true },
  { path: "/assessments", clickable: true },
  { path: "/assessments/:assessmentName", clickable: true },
  { path: "/assessments/:assessmentName/:type/confirm-start", clickable: true },
  { path: "/assessments/:assessmentName/start-mcq", clickable: false },
  { path: "/assessments/:assessmentName/start-practical", clickable: true},
  { path: "/assessments/:assessmentName/review-mcq", clickable: true},
  { path: "/assessments/:assessmentName/review-practical", clickable: true},
  { path: "/quiz-dashboard", clickable: true },
  { path: "/masters-quizzes", clickable: true },
  { path: "/masters-quizzes/add", clickable: true },
  { path: "/masters-quizzes/:quizName", clickable: true },
  { path: "/masters-quizzes/:quizName/mcq", clickable: true},
  { path: "/masters-quizzes/:quizName/mcq/import", clickable: true },
  { path: "/masters-quizzes/:quizName/attendees", clickable: true },
  { path: "/masters-quizzes/:quizName/sessions", clickable: true },
  { path: "/masters-quizzes/:quizName/attendees/:name", clickable: true },
  { path: "/quizzes", clickable: true },
  { path: "/quizzes/:quizName/start", clickable: false},
  { path: "/quizzes/:quizName/review", clickable: false },
  { path: "/support", clickable: true },
  { path: "/support/add", clickable: true },
  { path: "/agents", clickable: true },
  { path: "/reports", clickable: true },
  { path: "/reports/quiz-report", clickable: true },
  { path: "/reports/assessment-report", clickable: true },
  { path: "/reports/assessment-practical-report", clickable: true },
  { path: "/reports/incident-report", clickable: true },
  { path: "/reports/incident-mis-report", clickable: true },
  { path: "/reports/bay-login-report", clickable: true },
  { path: "/reports/bay-sessions-report", clickable: true },
  { path: "/reports/login-history-report", clickable: true },
  { path: "/reports/recent-login-history-report", clickable: true },
  { path: "/assigned-tickets", clickable: true },
  { path: "/assigned-tickets/tickets", clickable: true },
  { path: "/masters-faq", clickable: true },
  { path: "/masters-faq/import", clickable: false },
  { path: "/masters-faq/add", clickable: true },
  { path: "/masters-faq/edit/:type/:name", clickable: false },
  { path: "/faq", clickable: true },
  { path: "/faq/:faqType", clickable: true },
  { path: "/expert-sessions", clickable: true},
  { path: "/expert-sessions/:sessionTitle", clickable: false},
  { path: "/expert-sessions/add", clickable: true },
  { path: "/expert-sessions/edit/:sessionTitle", clickable: false },
  { path: "/bay", clickable: true },
];

const Breadcrumbs = () => {
  const location = useLocation();
  const { theme } = useContext(ThemeContext);
  const { state } = location;
  const isDark = theme === "dark";

  const pathnames = location.pathname.split("/").filter((x) => x);
  const isRoot = pathnames.length === 0;
  const isOnlyDashboard = pathnames.length === 1 && pathnames[0] === "dashboard";
  const textClass = isDark ? "text-light" : "#003366";
  const slashColor = isDark ? "#aaa" : "#555";

  const getBreadcrumbInfo = (routeTo, segment, index) => {
    let matchedRoute = routeConfig.find((route) =>
      matchPath({ path: route.path, end: true }, routeTo)
    );
    const fullPathMatch = routeConfig.find((route) =>
      matchPath({ path: route.path, end: true }, location.pathname)
    );

const formatText = (text = "") => {
  return decodeURIComponent(text)
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .replace(/\b(i|ii|iii|iv|v|vi|vii|viii|ix|x)\b/gi, (match) =>
      match.toUpperCase()
    );
};

  let displayName = formatText(segment);

    if (!matchedRoute && !fullPathMatch) {
      return { name: displayName, isClickable: false, routeTo };
    }
    matchedRoute = matchedRoute || fullPathMatch;

    const params = matchPath(matchedRoute.path, routeTo)?.params || matchPath(matchedRoute.path, location.pathname)?.params || {};
    Object.keys(params).forEach((param) => {
      if (segment === params[param]) {
        const paramName =
          state && state[param] ? state[param] : params[param] || segment;
   displayName = formatText(String(paramName));
      }
    });

    const isLastSegment = index === pathnames.length - 1;
    const isPartOfNonClickableRoute = fullPathMatch && !fullPathMatch.clickable && (
      !matchedRoute || matchedRoute.path !== routeTo || !matchedRoute.clickable
    );
    const isClickable = matchedRoute && matchedRoute.clickable && !isLastSegment && !isPartOfNonClickableRoute;
    let resolvedRoute = routeTo;
    if (!isClickable || isLastSegment) {
      resolvedRoute = `/${pathnames.slice(0, index).join("/")}` || "/";
    } else if (Object.keys(params).length > 0 && matchedRoute.clickable) {
      resolvedRoute = matchedRoute.path;
      Object.keys(params).forEach((param) => {
        resolvedRoute = resolvedRoute.replace(`:${param}`, params[param]);
      });
    }

    return { name: displayName, isClickable, routeTo: resolvedRoute };
  };

  return (
    <div className="container-fluid custom-container">
      <nav aria-label="breadcrumb" className="pt-3">
        <ol className="d-flex flex-wrap align-items-center p-0 m-0 list-unstyled">
          {isRoot || isOnlyDashboard ? (
            <li className={`breadcrumb-item active ${textClass}`} aria-current="page">
              Dashboard
            </li>
          ) : (
            <>
              <li className={`fw-bold ${textClass}`}>
                <Link
                  className={`text-decoration-none ${textClass}`}
                  to="/"
                  style={{ color: "#003366" }}
                >
                  Home
                </Link>
              </li>

              {pathnames.map((segment, index) => {
                const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
                const isLast = index === pathnames.length - 1;
                const { name, isClickable, routeTo: resolvedRoute } = getBreadcrumbInfo(
                  routeTo,
                  segment,
                  index
                );

                return (
                  <span key={index} className="d-flex align-items-center">
                    <span style={{ color: slashColor, margin: "0 6px" }}>
                      <FaChevronRight size={13} />
                    </span>
                    {isLast || !isClickable ? (
                      <span
                        className={`breadcrumb-item active ${textClass}`}
                        aria-current={isLast ? "page" : undefined}
                        style={{ color: "#003366" }}
                      >
                        {name}
                      </span>
                    ) : (
                      <Link
                        className={`text-decoration-none ${textClass}`}
                        to={{ pathname: resolvedRoute, state }}
                        style={{ color: "#003366" }}
                      >
                        {name}
                      </Link>
                    )}
                  </span>
                );
              })}
            </>
          )}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;